import { render, staticRenderFns } from "./CrossCountryObstacleComponent.vue?vue&type=template&id=11a1cd77&scoped=true"
import script from "./CrossCountryObstacleComponent.vue?vue&type=script&lang=ts"
export * from "./CrossCountryObstacleComponent.vue?vue&type=script&lang=ts"
import style0 from "./CrossCountryObstacleComponent.vue?vue&type=style&index=0&id=11a1cd77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a1cd77",
  null
  
)

export default component.exports